import i18n from '@/plugins/i18n'
import Model from './BaseModel'

export default class ErpWebhook extends Model {
    resourceName() {
        return 'erp-webhooks'
    }

    fields() {
        return ['id', 'action', 'payload', 'processed', 'created_at']
    }

    dates() {
        return {
            created_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedCreatedAt(erpWebhook) {
                return erpWebhook.created_at.isValid()
                    ? i18n.d(erpWebhook.created_at, 'datetime')
                    : null
            },
            type(erpWebhook) {
                return erpWebhook.action
            },
            processedAsText(erpWebhook) {
                return erpWebhook.processed ? 'Sim' : 'Não'
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: 'ID',
                value: 'id',
                sortable: false,
            },
            {
                text: 'Action',
                value: 'type',
                sortable: false,
            },
            {
                text: 'Processed',
                value: 'processedAsText',
                sortable: false,
            },
            {
                text: 'Created At',
                value: 'formattedCreatedAt',
                sortable: false,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'process',
                label: 'Process',
                disabled: this.processed,
                icon: 'mdi-play-circle',
            },
        ]
    }

    async process() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/process`,
            method: 'PUT',
        })
    }
}
